function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { unit } from '@ant-design/cssinjs';
import { genStyleHooks } from '../../theme/internal';
var genLayoutStyle = function genLayoutStyle(token) {
  var antCls = token.antCls,
    componentCls = token.componentCls,
    colorText = token.colorText,
    footerBg = token.footerBg,
    headerHeight = token.headerHeight,
    headerPadding = token.headerPadding,
    headerColor = token.headerColor,
    footerPadding = token.footerPadding,
    fontSize = token.fontSize,
    bodyBg = token.bodyBg,
    headerBg = token.headerBg;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, componentCls, _defineProperty(_defineProperty(_defineProperty({
    display: 'flex',
    flex: 'auto',
    flexDirection: 'column',
    /* fix firefox can't set height smaller than content on flex item */
    minHeight: 0,
    background: bodyBg,
    '&, *': {
      boxSizing: 'border-box'
    }
  }, "&".concat(componentCls, "-has-sider"), _defineProperty({
    flexDirection: 'row'
  }, "> ".concat(componentCls, ", > ").concat(componentCls, "-content"), {
    // https://segmentfault.com/a/1190000019498300
    width: 0
  })), "".concat(componentCls, "-header, &").concat(componentCls, "-footer"), {
    flex: '0 0 auto'
  }), '&-rtl', {
    direction: 'rtl'
  })), "".concat(componentCls, "-header"), _defineProperty({
    height: headerHeight,
    padding: headerPadding,
    color: headerColor,
    lineHeight: unit(headerHeight),
    background: headerBg
  }, "".concat(antCls, "-menu"), {
    lineHeight: 'inherit'
  })), "".concat(componentCls, "-footer"), {
    padding: footerPadding,
    color: colorText,
    fontSize: fontSize,
    background: footerBg
  }), "".concat(componentCls, "-content"), {
    flex: 'auto',
    color: colorText,
    // fix firefox can't set height smaller than content on flex item
    minHeight: 0
  });
};
export var prepareComponentToken = function prepareComponentToken(token) {
  var colorBgLayout = token.colorBgLayout,
    controlHeight = token.controlHeight,
    controlHeightLG = token.controlHeightLG,
    colorText = token.colorText,
    controlHeightSM = token.controlHeightSM,
    marginXXS = token.marginXXS,
    colorTextLightSolid = token.colorTextLightSolid,
    colorBgContainer = token.colorBgContainer;
  var paddingInline = controlHeightLG * 1.25;
  return {
    // Deprecated
    colorBgHeader: '#001529',
    colorBgBody: colorBgLayout,
    colorBgTrigger: '#002140',
    bodyBg: colorBgLayout,
    headerBg: '#001529',
    headerHeight: controlHeight * 2,
    headerPadding: "0 ".concat(paddingInline, "px"),
    headerColor: colorText,
    footerPadding: "".concat(controlHeightSM, "px ").concat(paddingInline, "px"),
    footerBg: colorBgLayout,
    siderBg: '#001529',
    triggerHeight: controlHeightLG + marginXXS * 2,
    triggerBg: '#002140',
    triggerColor: colorTextLightSolid,
    zeroTriggerWidth: controlHeightLG,
    zeroTriggerHeight: controlHeightLG,
    lightSiderBg: colorBgContainer,
    lightTriggerBg: colorBgContainer,
    lightTriggerColor: colorText
  };
};
// ============================== Export ==============================
export var DEPRECATED_TOKENS = [['colorBgBody', 'bodyBg'], ['colorBgHeader', 'headerBg'], ['colorBgTrigger', 'triggerBg']];
export default genStyleHooks('Layout', function (token) {
  return [genLayoutStyle(token)];
}, prepareComponentToken, {
  deprecatedTokens: DEPRECATED_TOKENS
});